module.exports = __webpack_public_path__ + "img/public/SiteIcons/noReviewIcon.svg?5b83ae7d";